import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Box, Badge } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import { useSearchParams } from "react-router-dom";

const CustomTabs = ({ tabs }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const isValidTab = tabs.some((tabItem) => tabItem.value === tab);

  const value = tab && isValidTab ? tab : tabs[0]?.value;

  const handleChange = (event, value) => {
    setSearchParams({ ...Object.fromEntries(searchParams), tab: value });
  };

  return (
    <div>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 'none', borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              sx={{
                "& .MuiTab-root": {
                  color: "#999999", // Default color of tabs
                },
                "& .MuiTab-root.Mui-selected": {
                  color: "#7CA7AD", // Color of selected tab
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#7CA7AD", // Color of the tab indicator (underline)
                },
                margin: '10px 0px 25px 0px'
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  value={tab.value}
                  sx={{
                    fontSize: "0.8rem",
                    textTransform: 'capitalize',
                  }}
                  label={
                    <Badge
                      color="error"
                      variant={tab.error ? "dot" : "standard"}
                    >
                      {tab.label}
                    </Badge>
                  }
                  key={index}
                />
              ))}
            </Tabs>
        </Box>
        {tabs.map((tab, index) => (
          <TabPanel value={tab.value} key={index} sx={{p: 0}}>
            {tab.component}
          </TabPanel>
        ))}
      </TabContext>
    </div>
  );
};

CustomTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      component: PropTypes.node.isRequired,
      error: PropTypes.bool,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CustomTabs;